import { defineComponent as _defineComponent } from 'vue'
import QConservedPoliciesDrilldown from "@/components/stats/scorecards/QConservedPoliciesDrilldown.vue";
import QMyClientsSubmenu from "@/components/navigation/Submenus/QMyClientsSubmenu.vue";
import { useUser } from "../../composables/useUser";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConservedPolices',
  setup(__props) {

const user = useUser();

return { __sfc: true,user, QConservedPoliciesDrilldown, QMyClientsSubmenu }
}

})